import { Box, Button } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'
import { useEffect, useState } from 'react'
import TimeHelper from '../../helpers/TimeHelper'
import { useAppSelector } from '../../store/Hooks'
import Tile from '../layout/Tile'
import TextLink from './TextLink'
import { useDispatch } from 'react-redux'
import { setTimeSettings } from '../../store/slices/AppSlice'

interface P {
    width: number
}

function TimePopover({ width }: P) {
    const dispatch = useDispatch()
    const time = useAppSelector(s => s.app.timeSettings ?? TimeHelper.timeSettings())
    const [from, setFrom] = useState(moment.utc(time.from))
    const [to, setTo] = useState(moment.utc(time.to))

    useEffect(() => {
        setFrom(moment.utc(time.from))
        setTo(moment.utc(time.to))
    }, [])

    const fromIsValid = (from: moment.Moment) => from <= to
    const toIsValid = (to: moment.Moment) => to >= from

    const onClickPresetDate = (month?: number) => {
        const now = TimeHelper.now()
        setTo(now)

        const from = now.clone().subtract(month - 1, 'M').startOf('month')
        setFrom(from)
    }

    const onChangeDate = (date: 'from' | 'to', momentDate: moment.Moment) => {
        if (date === 'from') {
            setFrom(momentDate?.startOf('month') ?? null)
        } else {
            setTo(momentDate?.endOf('month') ?? null)
        }
    }

    const onSubmit = e => {
        e.preventDefault()

        if (fromIsValid(from) && toIsValid(to) && (from || to)) {
            dispatch(setTimeSettings({ ...time, from: from && from.format('YYYY-MM-DD'), to: to && to.format('YYYY-MM-DD') }))
        } else {
            console.log(from, toIsValid(to))
        }
    }

    return (
        <Tile.Column flex={0} style={{ width: width, padding: 6 }}>
            <form onSubmit={onSubmit}>
                <Box padding={2} borderRadius={3}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <Box>
                            <DatePicker
                                value={from}
                                maxDate={to}
                                label='From'
                                timezone='UTC'
                                views={['year', 'month']}
                                onChange={m => onChangeDate('from', m)}
                            />
                        </Box>
                        <Box marginTop={2}>
                            <DatePicker
                                value={to}
                                minDate={from}
                                label='To'
                                timezone='UTC'
                                views={['year', 'month']}
                                onChange={m => onChangeDate('to', m)}
                            />
                        </Box>
                    </LocalizationProvider>
                </Box>
                <Box flex={1} display='flex' flexDirection='column' justifyContent='flex-start' padding={2} borderRadius={3} marginTop={1}>
                    <TextLink style={{ fontSize: 18, marginBlock: 2 }} onClick={() => onClickPresetDate(3)}>Last 3 Months</TextLink>
                    <TextLink style={{ fontSize: 18, marginBlock: 2 }} onClick={() => onClickPresetDate(6)}>Last 6 Months</TextLink>
                    <TextLink style={{ fontSize: 18, marginBlock: 2 }} onClick={() => onClickPresetDate(12)}>Last 12 Months</TextLink>
                </Box>
                <Button type='submit' fullWidth variant='contained' sx={{ marginTop: 2 }}>Apply</Button>
            </form>
        </Tile.Column>
    )
}

export default TimePopover
